export default __webpack_public_path__ + "static/media/backgroundSvg.96adb17a.zip";